import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { bem } from 'helpers/class-name';

import './Callout.scss';

const { block, modifier } = bem('callout');

const Callout = ({ icon, variant = 'info', children, className }) => (
  <div className={classNames(block(), className, modifier(variant))}>
    <>
      {icon}
      {children}
    </>
  </div>
);

Callout.propTypes = {
  icon: PropTypes.node,
  variant: PropTypes.oneOf(['info', 'warning', 'error']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Callout;
